import HealthCardPage from "./HealthCardPage";
export default HealthCardPage;
